import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-customer-style1',
  templateUrl: './customer-style1.component.html',
  styleUrls: ['./customer-style1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomerStyle1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/customers/customer-style1/customer-style1.component.ts